var exports = {
  "JC": "UserProfilePopout.module__role___LUlQaT",
  "s$": "UserProfilePopout.module__roleRemoveIcon___LUlQaT",
  "Bx": "UserProfilePopout.module__iconSmall___LUlQaT",
  "v0": "UserProfilePopout.module__iconMedium___LUlQaT",
  "bc": "UserProfilePopout.module__profileCustomStatus___LUlQaT",
  "CQ": "UserProfilePopout.module__profileCustomStatusText___LUlQaT",
  "ZB": "UserProfilePopout.module__profileDisplayName___LUlQaT",
  "yn": "UserProfilePopout.module__profileDataWarning___LUlQaT",
  "mC": "UserProfilePopout.module__profilePanel___LUlQaT",
  "OZ": "UserProfilePopout.module__footerRow___LUlQaT",
  "aN": "UserProfilePopout.module__profileButton___LUlQaT",
  "zF": "UserProfilePopout.module__profilePopoutCard___LUlQaT",
};

module.exports = exports;
